export default class {
    constructor(dataObject = null) {
        this.Id = 0;
        this.ManufactureRep = '';

        // Import data if set
        if (dataObject) {
            try {
                this.Id = dataObject.id;
                this.ManufactureRep = dataObject.ManufactureRep;
            } catch (e) {
                throw 'Data import error @ ManufactureRepMaster data.';
            }
        }
    }
}
